import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export const combinationPaths = {
  "NC-Student View-1st-Science": "/pages/nc1stscience.js",
  // Add more combinations as needed
};

const AdminTools = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h1>Admin Settings Placeholder</h1>
      <button
        onClick={() => navigate("/")}
        style={{
          padding: "15px 30px",
          fontSize: "18px",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "10px",
          cursor: "pointer",
          marginTop: "20px",
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        Go to Home
      </button>
    </div>
  );
};

const AdminSettings = () => {
  const [combinations, setCombinations] = useState(combinationPaths);
  const [newCombination, setNewCombination] = useState({
    key: "",
    path: ""
  });

  const navigate = useNavigate(); // Add useNavigate hook

  const handleAddCombination = () => {
    if (newCombination.key && newCombination.path) {
      setCombinations({
        ...combinations,
        [newCombination.key]: newCombination.path
      });
      setNewCombination({ key: "", path: "" });
    } else {
      alert("Please fill in both fields.");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Admin Settings</h1>
      <p>Here you can manage the combinations and paths for AdminTools.js.</p>
      <div>
        <input
          type="text"
          placeholder="Combination Key (e.g., NC-Student View-1st-Science)"
          value={newCombination.key}
          onChange={(e) => setNewCombination({ ...newCombination, key: e.target.value })}
          style={{ marginRight: "10px", padding: "5px" }}
        />
        <input
          type="text"
          placeholder="Path (e.g., /pages/nc1stscience.js)"
          value={newCombination.path}
          onChange={(e) => setNewCombination({ ...newCombination, path: e.target.value })}
          style={{ marginRight: "10px", padding: "5px" }}
        />
        <button onClick={handleAddCombination} style={{ padding: "5px 10px" }}>
          Add Combination
        </button>
      </div>
      <div style={{ marginTop: "20px" }}>
        <h2>Existing Combinations</h2>
        <ul>
          {Object.entries(combinations).map(([key, path]) => (
            <li key={key}>
              {key}: {path}
            </li>
          ))}
        </ul>
      </div>
      <button 
        onClick={() => navigate("/manage-quizzes")} 
        style={{ padding: "10px 20px", marginTop: "20px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}
      >
        Manage Quizzes
      </button>
    </div>
  );
};

export default AdminSettings;
